<template>
  <div class="home-section-state home-section-state--empty">
    <span class="home-section-state__icon" aria-hidden="true">+</span>
    <p>{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "HomeSectionEmpty",
  props: {
    message: { type: String, default: "Nada para mostrar por enquanto." },
  },
};
</script>
